import { render, staticRenderFns } from "./PlaceList.vue?vue&type=template&id=16fc9cc2&"
import script from "./PlaceList.vue?vue&type=script&lang=ts&"
export * from "./PlaceList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports